import './ActionButtons.css';

const ActionButton = (props) => {
  let classes = `ActionButton ${props.className}`;
  if (props.isActive) {
    classes += " active";
  }
  return ( 
    <button 
      className={classes}
      onClick={props.onClick}>
      {props.label}
    </button>
  );
}

export const ListButton = (props) => {
  return ( 
    <ActionButton 
      className="ListButton"
      label="&#9776;"
      isActive={props.isActive}
      onClick={props.onClick}
    />
  );
}

export const AddButton = (props) => {
  return ( 
    <ActionButton 
      className="AddButton" 
      label="+"
      isActive={props.isActive}
      onClick={props.onClick}
    />
  );
}

export const UploadButton = (props) => {
  return ( 
    <ActionButton 
      className="UploadButton" 
      label="&#8682;"
      isActive={props.isActive}
      onClick={props.onClick}
    />
  );
}

export const FAB = (props) => {
  return (
    <button className="fab" onClick={props.onClick}>+</button>
  );
}

export const DownloadButton = (props) => {
  const handleDownload = () => {
    const token = localStorage.getItem('zapmanejo_token');
    fetch(`/api/download/${props.collection}`, {
      headers: { 'Authorization': `Bearer ${token}` },
    })
      .then((res) => res.blob())
      .then((blob) => {
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${props.collection}.csv`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      });
  };
  return (
    <ActionButton
      className="DownloadButton"
      label="&#8679;"
      isActive={props.isActive}
      onClick={handleDownload}
    />
  );
}
